<template>
  <div>
    <h1>Protected Page</h1>
    <p>Congratulations! You have access because you hold the required token.</p>
    <router-link to="/">Back to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "ProtectedPage",
};
</script>
